import { User, Account } from '@app/models'
import { AuthState, getOriginalTokenUserId } from '@app/store/auth'

import { isB2BView } from '@app/utils'

import { appInsights } from './appInsights'

export const initAIuser = (
  authState: AuthState,
  user: User,
  account: Account
) => {
  if (document.location.hostname === 'localhost') {
    return
  }

  const originalTokenUserId = getOriginalTokenUserId(authState)
  const userId = user.id.toString()
  const accountId = account.id.toString()

  if (
    appInsights.context &&
    appInsights.context.user &&
    appInsights.context.user.authenticatedId != userId
  ) {
    appInsights.clearAuthenticatedUserContext()
  }

  let prefix = ''
  if (originalTokenUserId) {
    prefix = `-a-${originalTokenUserId}`
  }
  if (!isB2BView()) {
    prefix += '-pow'
  }

  const userContext = `${userId}${prefix}`
  appInsights.setAuthenticatedUserContext(userContext, accountId, true)
}
